import client from "./client";

export default {

    async getNotifications(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/notifications', filters)));
    },
    async createNotification(data) {
        return client.parseResponse(await client.post('/notifications', data))
    },
    async editNotification(data) {
        return client.parseResponse(await client.put('/notifications/' + data.id, data))
    },
    async markAsRead(data) {
        return client.parseResponse(await client.post('/read-notification/', data))
    },
    async deleteNotification(data) {
        return client.parseResponse(await client.delete('/notifications/' + data.id))
    }
}
